module.exports = "/_next/static/images/ornaments-4852cf1c5eb001b71613021af03ebc90.png";